//@ts-check
export const BUSINESS_IDENTIFIER_MINLEN = 3
export const BUSINESS_IDENTIFIER_MAXLEN = 50
export const BUSINESS_NAME_MINLEN = 3
export const BUSINESS_NAME_MAXLEN = 50

export const supportedLanguages = [
    'en/English',
    'da/Danish',
    'nl/Dutch',
    'fr/French',
    'de/German',
    'hi/Hindi',
    'it/Italian',
    'pl/Polish',
    'pt/Portuguese',
    'ru/Russian',
    'es/Spanish',
    'se/Swedish',
    'tr/Turkish',
]

/* DOCUMENT EDITOR TOP LEFT ACTIONS COMPATIBILITY ARRAY */
// all: 'font', 'font_size', 'bold', 'italic', 'underline', 'color', 'required_field', 'read_only', 'field_label', 'fill_type', 'validation'
export const actionsCompatibility = {
    signature: ['required_field'],
    initials: ['required_field'],
    date_signed: [
        'open_style_options',
        'font',
        'font_size',
        'bold',
        'italic',
        'underline',
        'color',
    ],
    text: [
        'open_style_options',
        'font',
        'font',
        'font_size',
        'bold',
        'italic',
        'underline',
        'color',
        'required_field',
        'read_only',
        'field_label',
        'fill_type',
        'validation',
    ],
    text_single: [
        'open_style_options',
        'font',
        'font',
        'font_size',
        'bold',
        'italic',
        'underline',
        'color',
        'required_field',
        'read_only',
        'field_label',
        'fill_type',
        'validation',
    ],
    checkbox: ['required_field', 'read_only', 'field_label', 'fill_type'],
    radio: ['required_field', 'read_only', 'field_label', 'fill_type'],
    dropdown: [
        'open_style_options',
        'font',
        'font',
        'font_size',
        'bold',
        'italic',
        'underline',
        'color',
        'required_field',
        'read_only',
        'field_label',
        'fill_type',
    ],
    attachment: ['required_field'],
    checkboxGroup: ['required_field', 'field_label', 'fill_type'],
    image: ['required_field'],
}
